import { ModelBase } from '../../core/model/model-base';
import { InvoiceDeliveryMethod } from './const/enum';
import { PostalAddress } from '../../common/model/postal-address';

export class InvoiceDeliveryConfiguration extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      ((this.id = dataContext.id), (this.email = dataContext.email));
      this.deliveryMethod = dataContext.deliveryMethod ? dataContext.deliveryMethod : InvoiceDeliveryMethod.Manual;
      this.recipientContactId = dataContext.recipientContactId;
      this.postalAddress = new PostalAddress(dataContext.postalAddress);
    } else {
      this.postalAddress = new PostalAddress();
    }
  }

  email: string;
  deliveryMethod: InvoiceDeliveryMethod;
  recipientContactId: string;
  postalAddress: PostalAddress;
}
